import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import * as _ from 'lodash-es';

import { appToolkit } from '../app/slice';

import type { DeleteModuleUser, ModuleUser, ProcessModuleUserPayload, SetModulePayload } from './state';
import { initialCurrentState } from './state';
import { baseSelectors, currentModuleSelectors } from './selectors';

const slice = createSlice({
  name: 'currentModule',
  initialState: initialCurrentState,
  reducers: {
    setModule: (state, action: PayloadAction<SetModulePayload | undefined>) => {
      const { moduleClass, entityId, disableUserAtNotifications } = action.payload || {};
      state.moduleClass = moduleClass;
      state.entityId = entityId;
      state.disableUserAtNotifications = disableUserAtNotifications;
    },
    processModuleUser: (state, action: PayloadAction<ProcessModuleUserPayload>) => {
      const ephemeralUserAt = action.payload;
      if (
        !!ephemeralUserAt.userID &&
        !!ephemeralUserAt.userName &&
        ephemeralUserAt.appID !== undefined &&
        !!ephemeralUserAt.appName
      ) {
        const moduleUser: ModuleUser = {
          ...ephemeralUserAt,
          userID: ephemeralUserAt.userID,
          userName: ephemeralUserAt.userName,
          appID: ephemeralUserAt.appID,
          appName: ephemeralUserAt.appName,
        };
        state.onlineUsers[ephemeralUserAt.userID] = moduleUser;
      }
    },
    deleteModuleUser: (state, action: PayloadAction<DeleteModuleUser>) => {
      const ephemeralUserDisconnected = action.payload;
      if (ephemeralUserDisconnected.userID) {
        state.onlineUsers = _.omit(state.onlineUsers, ephemeralUserDisconnected.userID);
      }
    },
    setLinkToTheLastModulePage: (state, action: PayloadAction<string>) => {
      state.linkToTheLastModulePage = action.payload;
    },
    setIsSpaceLessModule: (state, action: PayloadAction<boolean>) => {
      state.isSpaceLessModule = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appToolkit.actions.startAppSelecting, (state) => {
      state.onlineUsers = {};
    });
  },
});

export const currentModuleToolkit = Object.freeze({
  initialState: initialCurrentState,
  actions: slice.actions,
  selectors: {
    ...baseSelectors,
    ...currentModuleSelectors,
  },
});

export const currentModuleReducer = slice.reducer;
